import { BaseEntity } from "yt-ng-framework";

export class OsobaTelefonView extends BaseEntity{
    constructor(){
        super();
    }

    Glavni:boolean = null;
    VrstaTelefona:string = null;
    Broj:string = null;
    Lokal:string = null;
    Svojina:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Glavni=input.Glavni;
        this.VrstaTelefona=input.VrstaTelefona;
        this.Broj=input.Broj;
        this.Lokal=input.Lokal;
        this.Svojina=input.Svojina;
        return this;
    }

    Serialize(input:OsobaTelefonView){
        return input;
    }
}